module.exports = __webpack_public_path__ + "img/brasao.26538789.png";